<!-- Button to provide quittieren function including Dialog -->
<template>
  <div v-if="showConfirmationButton">
    <v-list-item v-if="listItem" @click="acknowledgeDialog = true">
      <v-list-item-icon>
        <v-icon>mdi-pencil</v-icon>
      </v-list-item-icon>
      <v-list-item-subtitle class="wrap-normal">{{ $t('acknowledge.action') }}</v-list-item-subtitle>
    </v-list-item>
    <icon-text-btn
      v-else
      @onClick="acknowledgeDialog = true"
      icon="mdi-pencil"
      :text="$t('acknowledge.action')"
      :hint="$t('acknowledge.action')"
      :iconColor="color"
      :iconOnly="false"
      :small="small"
      :noWrap="noWrap"
    ></icon-text-btn>
    <!-- <v-btn v-else
           rounded
           x-small
           text
           :class="`py-4 ${color}--text`"
           @click.stop="acknowledgeDialog = true">
      {{ $t('acknowledge.action') }}
      <v-icon>mdi-pencil</v-icon>
    </v-btn> -->
  </div>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import IconTextBtn from './IconTextBtn.vue';

export default {
  name: 'AcknowledgeButton',
  mixins: [common, configMixin],
  components: {
    IconTextBtn,
  },
  props: {
    listItem: {
      type: Boolean,
      default: false,
    },
    document: { type: Object },
    moduleType: {
      type: String,
      required: true,
    },
    documentTitle: {
      type: String,
    },
    color: {
      type: String,
    },
    isRead: {
      type: String,
    },
    small: { type: Boolean, default: true },
    noWrap: { type: Boolean, default: false },
  },
  mounted() {
    this.init();
  },

  data() {
    return {
      dialog: false,
      docTitleToAcknowledge: this.documentTitle,
    };
  },

  computed: {
    moduleConfig() {
      return this.getModuleConfig(this.moduleType, this.$route.params.instance);
    },
    showConfirmationButton() {
      let { confirmationType } = this.moduleConfig;
      if (!confirmationType) {
        confirmationType = 'dialog';
      }
      return confirmationType !== 'autoConfirm';
    },
    acknowledgeDialog: {
      get() {
        return this.$store.state.acknowledgeDialog;
      },
      set() {
        let { confirmationType } = this.moduleConfig;
        if (!confirmationType) {
          confirmationType = 'dialog';
        }
        const displayDialog = confirmationType === 'dialog';
        this.$store.commit('setAcknowledgeDialog', { value: displayDialog });
        if (confirmationType === 'buttonOnly') {
          let sendboxTitle = this.$t('action.acknowledge.msg', { object: this.document.title });
          let snackbarText = sendboxTitle;

          //this.$store.dispatch(`${this.storeModule}/markAsAcknowledged`, { document: this.acknowledgeDocument });
          this.$store.dispatch(`sendbox/markAsAcknowledged2`, { item: this.document, sendboxTitle, snackbarText });

          //this.$store.commit(`documents/markAsAcknowledged`, { document: this.document });
        }
      },
    },
  },
  methods: {
    init() {
      this.$store.commit('setAcknowledgeDocument', { document: this.document });
      this.$store.commit('setAcknowledgeDialog', { value: false, acknowledgeCompleted: false });
    },
    acknowledge() {
      console.debug('acknowledge', this.acknowledgeDocument);
      if (this.acknowledgeDocument) {
        this.$store.commit(`documents/markAsAcknowledged`, { document: this.acknowledgeDocument });
        this.$store.commit('setAcknowledgeDialog', { value: false, acknowledgeCompleted: true });
      }
    },
  },
  watch: {
    document(newValue, oldValue) {
      console.debug('received new file to acknowledge', newValue);
      this.init();
      if (newValue !== oldValue && oldValue.quittierung === 1 && oldValue._userState && !oldValue._userState.dateconfirmed) {
        this.dialog = true;
        this.docTitleToAcknowledge = oldValue.title;
      }
    },
  },
};
</script>
